import session_id from './session_id';
const enigma = require('enigma.js');
const schema = require('enigma.js/schemas/12.20.0.json');
const config = {schema, url: `wss://sense-demo.qlik.com/app/engineData/identity/${session_id}`};



// export default enigma.create(config).open().then((global) => {
//   return global.openDoc('45841fc2-ae9c-490c-9bc4-55592fc62afb').then(doc => {
//     // return global.openDoc('22d17921-9e08-4593-93a4-272fae6f6b7c').then(doc => {
//     return doc;
//   });
//});


export default enigma.create(config).open().then((global) => {
  return global.openDoc('45841fc2-ae9c-490c-9bc4-55592fc62afb').then(doc => { 
  // return global.openDoc('5f816f73-fbc7-4c5a-ac26-eb98ec489a03').then(doc => { //2019data
    // let State1 = doc.addAlternateState("State1");
    // let State2 = doc.addAlternateState("State2");
    // let State3 = doc.addAlternateState("State3");
    // let State4 = doc.addAlternateState("State4");
    // return Promise.all([State1, State2, State3, State4]).then(() => {
    //   return doc;
    // });
    return doc;
  });
});





// WEBPACK FOOTER //
// ./qdoc.js